import { municipalitySchema } from '@ghp/domain';
import { z } from 'zod';
import { bearer } from './http.js';
/**
 * Le référentiel des communes (M8) — **une lecture, et c'est tout ce que la route offre**.
 *
 * Famille à part plutôt qu'un appel sur `inquiries` : le client suit les chemins de l'API, et une
 * commune n'est pas un sous-objet de la demande. Côté serveur le contrôleur vit dans le module
 * `inquiries` pour la raison inverse — c'est la chaîne d'adresse qui la fait exister —, et les
 * deux découpages n'ont pas à coïncider.
 */
export function createMunicipalitiesEndpoints(http) {
    return {
        /**
         * Les communes adressables, **déjà triées par nom** côté serveur (D24).
         *
         * ⚠️ Ne pas retrier à l'arrivée : l'ordre est celui que le sélecteur affiche, et un
         * `localeCompare` dans le navigateur le ferait dépendre de la locale du poste.
         */
        list(accessToken) {
            return http.get('/municipalities', z.array(municipalitySchema), bearer(accessToken));
        },
    };
}
//# sourceMappingURL=municipalities.js.map